import { createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";
import API from "../../../network/API";
import { createCIURL } from "../../../utils/helper";
import { ActorProfileMaster, EmployeeAccessPriviledge, IRejectWithValue, PhpResponse } from "../../../types";
import { phpClient } from "../../../network";
import { GetAllEmployeeRolesRequest } from "../../../types/request/user";
import { getUnreadNotifCount } from "../common";
import { Iron } from "@mui/icons-material";

export const logout = createAsyncThunk("/user/logout", async (version: number) => {
    try {
        const url = createCIURL(version, "/auth/logout");
        const response = await axios.get(url);
        return response.data;
    } catch (error) {}
});

export const getUsers = createAsyncThunk("/user/list", async (user: any) => {
    try {
        const response = await API.post("/employee-profile/user/list", user);
        return response.data;
    } catch (error) {}
});

export const getUserDetails = createAsyncThunk("/userInfo", async (_, { dispatch }) => {
    try {
        const response = await API.post("/user/user-info");
        if (response.data) {
            dispatch(
                getUnreadNotifCount({
                    employee_id: response.data.id || response.data.os_employee_id || response.data.os_emp_id,
                })
            );
        }
        return response.data;
    } catch (error) {}
});

export const getUserDetailsV2 = createAsyncThunk("/userInfoV2", async (_, { dispatch }) => {
    try {
        const response = await phpClient.post<PhpResponse<any>>({
            url: "/account/user_info",
        });
        if (response.data) {
            dispatch(
                getUnreadNotifCount({
                    employee_id: response.data.id || response.data.os_employee_id || response.data.os_emp_id,
                })
            );
        }
        return response.data;
    } catch (error) {}
});

export const accountIndex = createAsyncThunk<ActorProfileMaster, void, IRejectWithValue>(
    "/user/accountIndex",
    async (data, { rejectWithValue }) => {
        try {
            const response = await phpClient.get<PhpResponse<ActorProfileMaster>>({
                url: "/account/index",
            });
            return response.data ?? {};
        } catch (error) {
            const err = error as Error;
            return rejectWithValue(err.message || "An error occurred while fetching account index");
        }
    }
);

export const getUserDetailsMe = createAsyncThunk("/user/me", async () => {
    try {
        const response = await API.post("/user/user-info");
        return response.data;
    } catch (error) {}
});

export const getEmployeeAccessPrivileges = createAsyncThunk<EmployeeAccessPriviledge[], void, IRejectWithValue>(
    "user/getEmployeeAccessPrivileges",
    async (_, { rejectWithValue }) => {
        try {
            const response = await phpClient.get<PhpResponse<EmployeeAccessPriviledge[]>>({
                url: "/employees/accessprivileges",
            });

            return response.data ?? [];
        } catch (error: any) {
            return rejectWithValue(error.message || "An error occurred");
        }
    }
);

// export const getAccountIndex = createAsyncThunk();
